import React, { useState } from 'react';
import { useSnackbar } from 'notistack';
import PremiumPlusSnackbar, { subscriptionTypesMessage } from '../components/UI/CustomSnackbar';
import { Card, CardContent, CardHeader, Typography } from '@mui/material';
import { formatString } from '../utils/numbers';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import CancelIcon from '@mui/icons-material/Cancel';
import { red } from '@mui/material/colors';

export const useSnackbarNotification = () => {
	const { enqueueSnackbar, closeSnackbar } = useSnackbar();
	const [snackbarKey, setSnackbarKey] = useState(null);

	// Function to show generic error notifications
	const showErrorNotification = (errorMessage) => {
		const snkBarId = enqueueSnackbar(errorMessage ?? 'Actiune esuata', {
			variant: 'error',
			anchorOrigin: { horizontal: 'left', vertical: 'bottom' }
		});
		setSnackbarKey(snkBarId);
	};

	const showSuccessNotification = (message) => {
		const snkBarId = enqueueSnackbar(message ?? 'Actiune finalizata cu success', {
			variant: 'success',
			anchorOrigin: { horizontal: 'left', vertical: 'bottom' }
		});
		setSnackbarKey(snkBarId);
	};

	const showExplanation = (message) => {
		const snkBarId = enqueueSnackbar(message, {
			variant: 'info',
			anchorOrigin: { vertical: 'bottom', horizontal: 'center' },
			autoHideDuration: null,
			content: (key, message) => (
				<Card>
					<CardHeader
						action={
							<IconButton size="small" onClick={() => closeSnackbar(key)}>
								<CancelIcon sx={{ color: red[500], marginBottom: 'auto' }} />
							</IconButton>
						}
						title={
							<Typography component="span" variant="h6" fontWeight={'bold'}>
								Explicație răspuns
							</Typography>
						}
					></CardHeader>
					<CardContent>
						<Typography variant="body2" style={{ fontStyle: 'italic' }}>
							{formatString(message)}
						</Typography>
					</CardContent>
				</Card>
			)
		});

		setSnackbarKey(snkBarId);
	};
	// Function to show the Premium Plus upgrade notification
	const showPremiumPlusNotification = (message) => {
		const snkBarId = enqueueSnackbar(message ? message : 'Cont Premium Plus necesar', {
			variant: 'premiumPlus',
			persist: false,
			autoHideDuration: 5000,
			content: (key, msg, options) => (
				<PremiumPlusSnackbar id={key} fontColor="white" {...options} message={msg} />
			),
			preventDuplicate: true,
			TransitionProps: { direction: 'up' },
			anchorOrigin: { horizontal: 'center', vertical: 'bottom' }
		});
		setSnackbarKey(snkBarId);
	};

	const showPremiumNotification = () => {
		const snkBarId = enqueueSnackbar('Cont Premium necesar', {
			variant: 'premium',
			persist: true,
			content: (key, msg, options) => (
				<PremiumPlusSnackbar
					id={key}
					fontColor="white"
					subscriptionLinkTitle="cumpără"
					subscriptionTypesMessage={subscriptionTypesMessage[0]}
					{...options}
					message={msg}
				/>
			),
			preventDuplicate: true,
			TransitionProps: { direction: 'up' },
			anchorOrigin: { horizontal: 'center', vertical: 'bottom' }
		});
		setSnackbarKey(snkBarId);
	};

	// Optionally, a function to dismiss the snackbar
	const dismissSnackbar = () => {
		if (snackbarKey) {
			closeSnackbar(snackbarKey);
			setSnackbarKey(null);
		}
	};

	return {
		enqueueSnackbar,
		showSuccessNotification,
		showErrorNotification,
		showPremiumPlusNotification,
		showPremiumNotification,
		showExplanation,
		dismissSnackbar,
		snackbarKey
	};
};
